<!-- 测试方式 -->
<template>
  <BaseFormItem2
    class="test"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <div :class="{ 'is-loading': loading }">
      <BaseRadioGroup2 v-model="val" @change="handleEmit">
        <el-radio-button
          v-for="item in options"
          :key="item.value"
          :label="item.value"
          :disabled="item.disabled"
        >{{ item.label }}</el-radio-button>
      </BaseRadioGroup2>
      <i v-if="loading" class="el-icon-loading test__loading"></i>
    </div>
  </BaseFormItem2>
</template>

<script>
import { getFPCFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    // 测试方式展示(前端字段)
    view_test: {
      type: String,
      default: ''
    },
    testOptions: {
      type: Array,
      default: () => ([])
    },
    // 计价loading
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFPCFields('test')
    },
    // 是否显示未填写样式
    fillTips() {
      const { val } = this
      return !val
    },
    options() {
      const { fields, testOptions } = this
      if (testOptions && testOptions.length > 0) {
        return testOptions.map(({ real, word }) => ({ label: word, value: real }))
      }
      
      return fields.options
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
      this.handleEmitViewTest()
    }
  },
  methods: {
    handleEmit() {
      const { val, value } = this
      this.$emit('input', val)
      if (val != value) {
        this.$emit('change', val)
      }
      this.handleEmitViewTest()
      this.isShowError(false)
    },
    handleEmitViewTest() {
      const { val, options } = this
      const item = options.find(item => item.value == val)
      this.$emit('update:view_test', item ? item.label : '')
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.test {
  .is-loading {
    position: relative;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 99;
      background: rgba(255, 255, 255, 0.45);
    }
    .test__loading {
      margin-left: 10px;
      font-size: 16px;
    }
  }
}
</style>